<template>
  <div class="timeline-item is-primary">
    <div class="timeline-marker is-primary"></div>
    <div class="timeline-content has-text-left">
      <div class="is-border is-margin-top-xsmall">
        <div class="columns is-gapless has-background-white is-marginless-bottom is-minH50p is-flex">
          <div class="column is-self-centered is-padding-right is-padding-left">
            <div class="is-self-centered">
              <span class="is-uppercase title is-5 has-text-weight-normal">{{ event.date | dtFormat('DD MMMM YYYY') }}</span>
            </div>
          </div>
          <div
            v-if="!event.protected"
            class="column is-narrow has-background-white is-border-left is-flex">
            <a
              @click="openModalEvent()"
              data-tooltip="Modifier l'événement"
              class="page-header-btn is-small is-square tooltip is-tooltip-top">
              <span class="icon is-size-4">
                <i class="fal fa-edit"></i>
              </span>
            </a>
          </div>
          <div
            v-if="!(event.protected || isDisabled)"
            class="column is-narrow has-background-white is-border-left is-flex">
            <a
              @click="remove()"
              data-tooltip="Supprimer l'événement"
              class="page-header-btn is-small is-square tooltip is-tooltip-top">
              <span class="icon is-size-4">
                <i class="fal fa-trash-alt"></i>
              </span>
            </a>
          </div>
        </div>
        <div
          class="is-border-top is-padding"
          :class="[isDisabled ? 'has-content-disabled' : 'has-background-white']">
          <div class="columns is-gaplless">
            <div class="column is-1 is-2-widescreen is-3-fullhd"></div>
            <div class="column">
              <div class="is-padding-bottom-small">
                <div class="is-size-4">
                  {{ event.name }}
                </div>
              </div>
              <div class="is-padding-bottom-small">
                <p class="is-size-6">
                  {{ event.description }}
                </p>
              </div>
              <div>
                <a
                  @click="openModalDocument"
                  class="is-size-4">
                  <span>
                    <span>{{ event.documents.length }} document<span v-if="event.documents.length > 1">s</span></span> - <span>{{ event.pictures.length }} photo<span v-if="event.pictures.length > 1">s</span></span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeLineEvent',
  props: {
    event: {
      type: Object,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    from: {
      type: String,
      required: true
    }
  },
  computed: {
    /**
      * all documents
      * @returns {object}
      */
    allDocuments () {
      let allDocuments = {
        pictures: {
          documents: this.event.pictures,
          label: 'Photos'
        },
        documents: {
          documents: this.event.documents,
          label: 'Documents'
        }
      }
      return allDocuments
    },
    isDisabled () {
      if ('from' in this.event && this.event.from === 'program') {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    /**
      * open event modal
      */
    openModalEvent () {
      if (this.isDisabled && 'from_pk' in this.event) {
        this.$router.push({ name: 'ProgramBuyerSpace', params: { id: this.event.from_pk }, query: { panel: 'TIMELINE' } })
      } else {
        let params = {
          id: this.id,
          from: this.from,
          source: this.event
        }
        this.$store.commit('setModal', { mode: 'EVENT_MODAL', params })
      }
    },
    /**
      * open document modal
      */
    openModalDocument () {
      let params = {
        source: { ...this.allDocuments }
      }
      this.$store.commit('setModal', { mode: 'EVENT_DOCUMENT_MODAL', params })
    },
    /**
      * remove event
      */
    async remove () {
      try {
        await this.$api.delete(`/${this.from}/${this.id}/timeline`, this.event.pk)
        this.$emit('sliceEvent', this.event.pk)
        this.$toasted.global.success('Événement supprimé.')
      } catch (err) {
        console.log(err)
        this.$toasted.global.danger('Erreur lors de la suppression de l\'événement')
      }
    }
  }
}
</script>

<style lang="css">
  .timeline-content, .timeline-content > div {
    width: 100%;
  }
</style>
